import { render } from "./SortIcon.vue?vue&type=template&id=39601d3c&scoped=true"
import script from "./SortIcon.vue?vue&type=script&lang=js"
export * from "./SortIcon.vue?vue&type=script&lang=js"

import "./SortIcon.vue?vue&type=style&index=0&id=39601d3c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39601d3c"]])

export default __exports__